




















import ProductItem from '@pages/search/components/common/product_item.vue'
import { Component, Mixins, Prop, Watch, Provide, Inject } from 'vue-property-decorator'
import SearchCategory from '@pages/search/components/common/search_category.vue'
import SearchLoadList from '@pages/search/components/mixins/LoadList'
import Screen from '@pages/search/components/common/search_screen.vue'
import { List, Toast, Sticky } from 'vant'
import { getSearchResult, RequestType, CategoryList, DistrictBean, CategoryBean } from '@pages/search/search-service'
import { channelIdIsSendForm, creatCollectForm } from './utils'
import { CATEGORY_ID_MAP } from './emun'

@Component({
  components: {
    [List.name]: List,
    [Sticky.name]: Sticky,
    ProductItem,
    SearchCategory,
    Screen,
  },
})
export default class SearchProduct extends Mixins(SearchLoadList) {
  @Prop({ default: 176 / 75 + 'rem' }) readonly stickyTop!: number | string //吸顶的offsettop值 默认88 +88 一个titleBar和tab的高度
  @Prop({ default: 'transparent' }) readonly classifyColor!: string
  @Prop({ default: 90 }) readonly stickyHeight!: number
  @Prop() readonly tabindex!: number
  @Prop() readonly location!: any
  @Prop({ default: '' }) readonly category!: string
  @Prop({ default: '' }) readonly query!: string //产康选择itemtype的值
  @Prop({ default: () => [{ ID: '', NAME: '全城' }] }) readonly districtList!: DistrictBean[]

  @Inject('pageTrackParams')
  pageTrackParams!: any
  @Inject('clickid_tab_product')
  clickid_tab_product!: string

  @Provide()
  clickid_200005 = '200009'

  categoryList: CategoryList[] = [{ title: '全部', list: [{ title: '全部', categoryId: this.category }] }]
  productCategorySelect: CategoryBean = { title: '全部', categoryId: this.category }
  productDistrictSelect: DistrictBean = { ID: '', NAME: '全城' }
  productDistanceSort = true
  productSalesSort = false

  //距离排序是否展示
  get locationVis() {
    return this.location && this.location.lat && this.location.lng
  }

  //是否有筛选项
  get ishaveScreen() {
    return this.productDistanceSort || this.productSalesSort || this.productDistrictSelect.ID || this.productCategorySelect.categoryId != this.category
  }

  mounted() {
    this.onLoad()
  }

  @Watch('query')
  queryChange(val: string) {
    this.refresh()
  }

  get classifyExposure() {
    return `${this.clickid_tab_product}`
  }
  changeProductCategory(value: any) {
    this.$newClickTracker({ ...this.pageTrackParams, clickId: this.clickid_tab_product, positionParam: { searchtype: '分类' } })
    this.productCategorySelect = value
    this.refresh()
  }

  changeProductDistrict(value: any) {
    this.$newClickTracker({ ...this.pageTrackParams, clickId: this.clickid_tab_product, positionParam: { searchtype: '区域' } })
    this.productDistrictSelect = value
    this.refresh()
  }

  changeProductDistanceSort() {
    this.$newClickTracker({ ...this.pageTrackParams, clickId: this.clickid_tab_product, positionParam: { searchtype: '距离' } })
    if (this.loading) return
    this.productDistanceSort = !this.productDistanceSort
    if (this.productDistanceSort) {
      this.productSalesSort = false
    }
    this.refresh()
  }

  changeProductSalesSort() {
    this.$newClickTracker({ ...this.pageTrackParams, clickId: this.clickid_tab_product, positionParam: { searchtype: '销量' } })
    if (this.loading) return
    this.productSalesSort = !this.productSalesSort
    if (this.productSalesSort) {
      this.productDistanceSort = false
    }
    this.refresh()
  }

  async onLoad() {
    const channelId = +this.$route.params.channelId
    if (this.start === 10 && channelIdIsSendForm(channelId)) {
      // 发送收集表单需求
      // eslint-disable-next-line @typescript-eslint/ban-ts-comment
      // @ts-ignore
      const categoryId = CATEGORY_ID_MAP[channelId]
      const data = {
        categoryId: [categoryId],
        utm: 'lb', // 搜索渠道码写死lb
      }
      creatCollectForm(data)
    }
    const { categoryId = '' } = this.productCategorySelect || {}
    const { ID = '' } = this.productDistrictSelect || {}
    const result = await getSearchResult({ type: RequestType.RequestProduct, tabs: '3', query: this.query, start: this.start, openOption: this.categoryList.length === 1, position: this.location, level4CategoryId: categoryId, districtId: ID, distanceSort: this.productDistanceSort, saleNumSort: this.productSalesSort })
    const { code, data, msg } = result
    if (+code === 1) {
      if (data.categoryInfo && data.categoryInfo.length) {
        this.categoryList = this.getNewCategoryList(data.categoryInfo)
      }
      if (data.cmmdtyInfo) {
        const { list: newData = [] } = data.cmmdtyInfo
        if (newData.length < 10) {
          this.finished = true
        }
        this.start = this.start + newData.length
        this.list.push(...newData)
      }
    } else {
      this.errormsg = msg || '加载出错，请稍后再试'
      if (this.list.length > 0) {
        this.error = true
        Toast(this.errormsg)
      }
    }
    this.loading = false
  }

  refresh() {
    this.$emit('totop')
    this.reset()
    this.onLoad()
  }

  resetCondition() {
    this.$emit('totop')
    this.productCategorySelect = { title: '全部', categoryId: this.category }
    this.productDistrictSelect = { ID: '', NAME: '全城' }
    this.productDistanceSort = false
    this.productSalesSort = false
    this.refresh()
  }

  getNewCategoryList(payload: CategoryList[]) {
    payload.forEach((item: CategoryList) => {
      const num = item.list.length % 4
      const needAddTranslate = num > 1 ? 4 - num : 0 //>1的情况需要加几条空数据 方便ui  justify-content: space-between显示
      for (let index = 0; index < needAddTranslate; index++) {
        item.list.push({})
      }
    })
    return [{ title: '全部', list: [{ title: '全部', categoryId: this.category }] }, ...payload]
  }
}
